// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3jkfJ","noInteraction":"EventWrapper_noInteraction__286cg"};